import React, { FunctionComponent, memo } from "react";

import { Text } from "@/components/Text";
import { getJobRequestClientInfo, IJobRequest } from "@/data/job-requests";
import { Flex } from "@/eworkitComponents";
import { JobRequestClientAvatar } from "@/views/JobRequests/JobRequestClientAvatar/JobRequestClientAvatar";

interface IJobRequestManagedByDetailSectionProps {
  jobRequest: IJobRequest;
}

export const JobRequestManagedByDetailSection: FunctionComponent<IJobRequestManagedByDetailSectionProps> = memo(
  ({ jobRequest }) => {
    const { administratorName, administratorVatNumber } = getJobRequestClientInfo(jobRequest);

    return (
      <Flex direction="row" innerMargin="md">
        <Flex grow={1}>
          <JobRequestClientAvatar size="lg" jobRequest={jobRequest} administrator />
        </Flex>
        <Flex direction="column" innerMargin="xs">
          <Flex direction="column" innerMargin="xs">
            {administratorVatNumber && (
              <Text key="vatNumber" color="black">
                {administratorVatNumber}
              </Text>
            )}
            <Text key="website">{administratorName}</Text>
          </Flex>
          <Text>{jobRequest.managedByDescription}</Text>
        </Flex>
      </Flex>
    );
  },
);
